import React from "react";

import "./InlineBox.scss";

export type InlineBoxProps = {
  cx?: string;
  title?: string;
};

export const InlineBox: React.FC<InlineBoxProps> = ({
  cx = "",
  title,
  children,
}) => {
  return (
    <div className={`InlineBox ${cx}`}>
      {title && <span className={"title"}>{title}</span>}
      <div className="box">{children}</div>
    </div>
  );
};
